"use client";

import { NavButton } from "@/components/nav-button";
import { getHotelFunnelReturnUrlFromDocument } from "@/lib/checkout/integration-source";
import { useTranslations } from "next-intl";
import { useEffect, useState } from "react";

export function RootErrorNavButton() {
  const t = useTranslations("Common");
  const [hotelUrl, setHotelUrl] = useState<string>();
  const [loggedIn, setLoggedIn] = useState(false);

  useEffect(() => {
    setHotelUrl(getHotelFunnelReturnUrlFromDocument());
    setLoggedIn(
      document.cookie
        .split(";")
        .some((cookie) => cookie.trim().startsWith("logged_in=")),
    );
  }, []);

  if (hotelUrl) {
    return (
      <NavButton href={hotelUrl}>{t("button.backToHotelBooking")}</NavButton>
    );
  }

  if (!loggedIn) {
    return null;
  }

  return (
    <NavButton href={process.env.NEXT_PUBLIC_ACCOR_PLUS_URL}>
      {t("button.backToHome")}
    </NavButton>
  );
}
